import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesWorkflowTransitionMetaAttributesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflow-transition-meta-attributes',
	path: '/secure/admin/ViewWorkflowTransitionMetaAttributes.jspa',
};
